module.exports = __webpack_public_path__ + "images/ic-tower_and_wxwork@3x-60aa8b531af53e919b69247768cb3460.png";